import React, { useEffect } from "react";
import { Form, Input } from "antd";
import { STATUS } from "@/utils/enum";
import { Validator } from "@/utils/validator";

export default function VinInput({ formRef, onChange, disabledFields, readOnly, isAdmin, vinStatus }) {
  useEffect(() => {
    // Manually revalidate the vin field when the status changes
    if (vinStatus !== STATUS.IDLE) {
      formRef.validateFields(["vin"]);
    }
  }, [vinStatus]);

  return (
    <Form.Item
      name="vin"
      label="VIN"
      validateFirst
      rules={[
        Validator.required("VIN is required"),
        Validator.maxLength(17),
        !isAdmin && Validator.minLength(17),
        {
          validator: async () => {
            if (vinStatus === STATUS.ERROR) {
              return Promise.reject(new Error("Invalid VIN"));
            }
            return Promise.resolve();
          },
        },
      ]}
    >
      <Input
        onChange={e => onChange(e.target.value)}
        disabled={disabledFields || readOnly}
        style={{ color: "black" }}
      />
    </Form.Item>
  );
}
